import React from 'react';
import { connect } from 'react-redux';

import {
  MenuItem,
  IconMenu,
  ListItem,
} from 'material-ui';
import Icon from 'material-ui/svg-icons/maps/store-mall-directory';
import SuperUserIcon from 'material-ui/svg-icons/hardware/security';

import { userCheck as onUserCheck } from 'admin-on-rest/lib/actions/authActions';

import firestore from '../config/firestore-init';

const VenueSwitcher = ({ user, userCheck }) => {
  if (!user || (!user.venues && !user.superUser)) return null;

  const changeDefaultVenue = async (venue) => {
    await firestore.collection('users').doc(user.phoneNumber).set({ defaultVenue: venue }, { merge: true });
    userCheck({ changedVenue: true, user: { ...user, defaultVenue: venue } });
    // localStorage.setItem('user', JSON.stringify({ ...user, defaultVenue: venue }));
  };
  if (user.superUser) {
    return (
      <ListItem
        width="256px"
        style={{ display: 'block', color: 'rgb(183, 28, 28)', borderBottom: '1px solid rgba(183, 28, 28, 0.22)' }}
        primaryText="Super User"
        leftIcon={<SuperUserIcon />}
      />
    );
  }

  return (
    <IconMenu
      width="256px"
      style={{ display: 'block' }}
      iconButtonElement={<MenuItem primaryText={<span>Venue: <small>{user.defaultVenue}</small></span>} leftIcon={<Icon />} />}
    >
      {user.venues.sort().map((venue) => (
        <MenuItem key={venue} insetChildren primaryText={venue} onClick={() => changeDefaultVenue(venue)} checked={venue === user.defaultVenue} />
      ))}
    </IconMenu>
  );
};

export default connect((state) => state, { userCheck: onUserCheck })(VenueSwitcher);
